import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import { API_BASE_URL } from '../config/api'

export const useDeleteAccount = () => {
  const navigate = useNavigate()
  const [deleteLoading, setDeleteLoading] = useState(false)

  const deleteAccount = async () => {
    try {
      setDeleteLoading(true)
      await axios.delete(`${API_BASE_URL}/api/user/delete-account`, {
        withCredentials: true
      })

      alert('Your account has been successfully deleted.')
      navigate('/')
      return { success: true }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Delete account error:', error)
      alert(error.response?.data?.message || 'Failed to delete account. Please try again.')
      return { success: false, error: error.response?.data?.message || 'Delete failed' }
    } finally {
      setDeleteLoading(false)
    }
  }

  return {
    deleteAccount,
    deleteLoading
  }
}